import {Injectable} from "@angular/core";
import {HirUserService} from "../../api/services/hir-user.service";
import {map, tap} from "rxjs/operators";
import {Observable} from "rxjs";
import {NdmsUserManagementService} from "../../../../shared/core/app/api/services/ndms-user-management.service";


@Injectable()
export class HirUserManagementService {
  public static currentData: any;
  public static currentNdmsData: any;

  constructor(private userService:HirUserService, private ndmsUserManagementService: NdmsUserManagementService) {

  }

  getCurrentCachedUser() {
    if (HirUserManagementService.currentData && HirUserManagementService.currentData.key !== null) {
      return new Observable<any>((observer)=> {
        observer.next(HirUserManagementService.currentData);
      });
    }

    return this.userService.GetCurrent().pipe(map((res)=>{
      HirUserManagementService.currentData = res.model;
      return res.model
    }));
  }

  getCurrentCachedNdmsUser() {
    if(HirUserManagementService.currentNdmsData){
      return new Observable<any>((observer)=> {
        observer.next(HirUserManagementService.currentNdmsData);
      });
    }
    return this.ndmsUserManagementService.GetCurrentUser().pipe(map((res)=>{
      HirUserManagementService.currentNdmsData = res;
      return res
    }));
  }

  getCurrentUser() {
    return this.userService.GetCurrent().pipe(map((res)=>{
      HirUserManagementService.currentData = res.model || {};
      return res.model || {};
    }));
  }

  getCurrentNdmsUser() {
    return this.ndmsUserManagementService.GetCurrentUser().pipe(map((res)=>{
      HirUserManagementService.currentNdmsData = res || {};
      return res || {};
    }));
  }

  get() {
    return this.userService.Get().pipe(map((res)=>{
      return res;
    }));
  }
}
